export default "__VITE_ASSET__CT19AS2G__$_?inline__"